import { render, staticRenderFns } from "./validate-email.vue?vue&type=template&id=d2b74b7c&"
import script from "./validate-email.vue?vue&type=script&lang=js&"
export * from "./validate-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports